import { Apple } from "lucide-react";

export const AppStoreBadge = ({ testId = "app-store-badge", className = "" }) => (
  <a
    href="#"
    data-testid={testId}
    aria-label="Download on the App Store – link coming soon"
    className={`inline-flex items-center gap-3 rounded-[20px] border-2 border-[#1A1D1E] bg-[#1A1D1E] px-6 py-3 shadow-[0_5px_0_0_rgba(26,29,30,0.35)] transition-[transform,box-shadow] duration-150 hover:translate-y-[2px] hover:shadow-[0_3px_0_0_rgba(26,29,30,0.35)] active:translate-y-[5px] active:shadow-none focus:outline-none focus-visible:ring-4 focus-visible:ring-[#FFC837]/60 ${className}`}
  >
    <Apple className="h-8 w-8 fill-white text-white" />
    <span className="text-left leading-tight">
      <span className="block text-[11px] font-bold uppercase tracking-[0.18em] text-white/60">
        Download on the
      </span>
      <span className="block font-display text-xl font-semibold text-white">
        App Store
      </span>
    </span>
  </a>
);
